<template>
    <div>
        <slot />
        <brand-switcher-item :display-name="getCurrentAccountBrandNames" @switch="handleSwitch" />
    </div>
</template>

<script>
    import { EVENT_NAME_LIVE_SITE_SWITCHER_STARTED } from '../../../../../app-v2/constants/analytics-events';
    import useLiveSiteSwitcher from '../../../../composables/use-live-site-switcher';
    import useEventTracking from '../../../../composables/use-event-tracking';
    import { useContactStore } from '../../../../../stores';
    import BrandSwitcherItem from './BrandSwitcherItem.vue';

    export default {
        name: 'LiveSiteSwitcher',
        components: { BrandSwitcherItem },

        setup(props, { emit }) {
            const { getCurrentAccountBrandNames } = useLiveSiteSwitcher();

            const handleSwitch = () => {
                useEventTracking().trackEvent(EVENT_NAME_LIVE_SITE_SWITCHER_STARTED, {
                    contact_id: useContactStore().data?.id
                });

                emit('show-brands');
            };

            return {
                getCurrentAccountBrandNames,
                handleSwitch
            };
        }
    };
</script>
